import sharedApi from './shared';

// Shared catalogs (index/show only for applicants) and resource_texts (key/value
// store keyed by designator). Applicants cannot create catalog rows, so the CV
// wizard matches free text against these lists and only persists a match.
const catalogAPI = {
  getInstitutions: () => sharedApi.get('/education_institutions'),
  getDegrees: () => sharedApi.get('/education_degrees'),
  getCourses: () => sharedApi.get('/education_courses'),
  getLanguages: () => sharedApi.get('/languages'),

  // resource_texts — used for military service (designators: military,
  // military_year_start, military_year_end). find-or-update happens server-side.
  getResourceText: (designator) => sharedApi.get(`/resource_texts/${designator}`),
  saveResourceText: (designator, content) => sharedApi.post('/resource_texts', { designator, content }),
  deleteResourceText: (designator) => sharedApi.delete(`/resource_texts/${designator}`)
};

export default catalogAPI;
